import {NavLink} from "react-router-dom";
import './header.css'
import logo from '../../../assets/1.jpg'
import {useLocation} from "react-router";
function Header({type}) {
    const location = useLocation()
    return(
        <div className='header-block'>
            <div className='logo-block'>
                <NavLink to="/" ><img src={logo} alt=""/></NavLink>


            </div>
            { location.pathname === '/'&&
                <NavLink className='signIn-btn' to="/signIn" >
                    Մուտք
                </NavLink>
            }

        </div>
    );
}

export default Header;
